import endpoints, { axios } from "../../config/api";

async function getFile(folderId: string, fileId: string) {
  return await (await axios.get(endpoints.newfolders.file(folderId, fileId)))
    .data;
}

export default getFile;
